import { settingThemeStyle } from "./util";

export default function settingTheme() {
	if (typeof document === "undefined" || typeof window === "undefined") {
		return "light";
	}
	const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
	const applyTheme = (event: MediaQueryListEvent) => {
		const theme = event.matches ? "dark" : "light";
		settingThemeStyle(theme);
	};

	// 监听系统主题变化
	mediaQueryList.addEventListener("change", applyTheme);

	return mediaQueryList.matches ? "dark" : "light";
}
